import React from 'react';
import PropTypes from 'prop-types';
import IconWithLabel from '../../shared/IconWithLabel';

const BackorderedWarning = props => {
  const { product, translate } = props;
  if (
    !product ||
    !product.track_inventory ||
    !product.backorderable ||
    product.in_stock ||
    product.has_variants
  ) {
    return null;
  }

  return (
    <IconWithLabel
      icon='clock'
      labelDataAidKey='BACKORDERED_ALERT_RENDERED'
      labelText={ translate('products.item_backordered') }
    />
  );
};

BackorderedWarning.propTypes = {
  product: PropTypes.object,
  translate: PropTypes.func
};

export default BackorderedWarning;
